import React, { useState, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import getText from '../../assets/locale/locale';
import { LocaleContext } from '../../contexts';
import './EJMatchGateway.scss';
import addDataLayerTrigger from '../../utils/addDataLayerTrigger/addDataLayerTrigger';
import DownloadButton from '../DownloadButton/DownloadButton';
import SaveResultsButton from '../SaveResultsButton/SaveResultsButton';

const EJMatchGateway = ({
  downloadingPdf,
  setDownloadingPdf,
  resultsToSendToDelegator,
  setNotificationContent,
  setNotificationOpen,
  query,
  sessionId,
  coldContactData,
  userComments,
  isWebProspect,
}) => {
  const locId = useContext(LocaleContext);
  const searchURL = getText(locId, 'Results', 'url', 'EJMatchGateway');
  const placeholderText = '';
  const [searchValue, setSearchValue] = useState(placeholderText);

  const inputOnFocus = (e) => {
    if (e.target.value === placeholderText) {
      e.target.value = '';
    }
  };

  const inputOnBlur = (e) => {
    if (e.target.value === '') {
      e.target.value = placeholderText;
    }
  };

  const submitSearch = () => {
    if (searchValue !== '' && searchValue !== placeholderText) {
      addDataLayerTrigger('ej-match-click', {
        'ej-match-search-query': searchValue,
      });
      const win = window.open(`${searchURL}${searchValue}`, '_blank');
      win.focus();
    }
  };

  const topOfResultsPage = useRef();

  return (
    <div className="ejMatch__wrapper" data-testid="ej-match-gateway">
      <div className="ejMatch__left-side">
        <div className="ejMatch__pass-message" data-testid="results-greeting">
          <h1 id="heading-no-focus" ref={topOfResultsPage} tabIndex="-1">
            {getText(locId, 'Results', 'heading', 'ResultsGreeting')}
          </h1>
          <p>
            {getText(
              locId,
              'Results',
              'greetingParagraphAlternate',
              'ResultsGreeting'
            )}
          </p>
          <div className="final-actions top-buttons">
            {isWebProspect ? (
                <SaveResultsButton 
                  resultsToSendToDelegator={resultsToSendToDelegator}
                  setNotificationContent={setNotificationContent}
                  setNotificationOpen={setNotificationOpen}
                  query={query}
                  sessionId={sessionId}
                />
                ) : (
                <DownloadButton
                  resultsToSendToDelegator={resultsToSendToDelegator}
                  downloadingPdf={downloadingPdf}
                  setDownloadingPdf={setDownloadingPdf}
                  setNotificationContent={setNotificationContent}
                  setNotificationOpen={setNotificationOpen}
                  coldContactData={coldContactData}
                  userComments={userComments}
                />
            )} 
          </div>
        </div>
      </div>

      <div className="ejMatch__right-side">
        <div className="ejMatch__content">
          <h2 className="ejMatch__header">
            {getText(locId, 'Results', 'header', 'EJMatchGateway')}
          </h2>

          <>
            <div className="ejMatch_connect-container">
              <p>
                {getText(locId, 'Results', 'matchBtnLabel', 'EJMatchGateway')}
              </p>
            </div>
            <div className="ejMatch__search-container input-control">
              <label htmlFor="searchFA">
                {getText(locId, 'Results', 'matchLabel', 'EJMatchGateway')}
              </label>
              <div className="input-control--input--wrap ejMatch__input">
                <input
                  type="text"
                  name="searchFA"
                  id="searchFA"
                  data-testid="ej-match-search-input"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  onFocus={inputOnFocus}
                  onBlur={inputOnBlur}
                />
              </div>
              <button
                type="submit"
                className="button ejMatch__btn ejMatch__btn--search"
                data-testid="ej-match-search-submit"
                onClick={submitSearch}
              >
                {getText(
                  locId,
                  'Results',
                  'matchSubmitButton',
                  'EJMatchGateway'
                )}
              </button>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

EJMatchGateway.propTypes = {
  downloadingPdf: PropTypes.bool.isRequired,
  setDownloadingPdf: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  resultsToSendToDelegator: PropTypes.object.isRequired,
  setNotificationContent: PropTypes.func.isRequired,
  setNotificationOpen: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  sessionId: PropTypes.string.isRequired,
  coldContactData: PropTypes.objectOf(PropTypes.string),
  userComments: PropTypes.string,
  isWebProspect: PropTypes.bool.isRequired,
};
EJMatchGateway.defaultProps = {
  coldContactData: {},
  userComments: '',
};

export default EJMatchGateway;
